import { Route } from '@angular/router';
import { AdminComponent } from './admin.component';
import { AuthGuardAdmin } from '@intranet/core/services/auth-guard.service';
import { AdminImportComponent } from './admin-import/admin-import.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminUserEditComponent } from './admin-users/manage/admin-user-edit.component';
import { AdminRolesComponent } from './admin-roles/admin-roles.component';
import { AdminDebugComponent } from './admin-debug/admin-debug.component';
import { AdminCurrencyComponent } from './admin-currency/admin-currency.component';
import { AdminGroupsComponent } from './admin-groups/admin-groups.component';
import { AdminBandsComponent } from './admin-bands/admin-bands.component';
import { AdminJobTypesComponent } from './admin-jobtypes/admin-jobtypes.component';
import { AdminTestMessagesComponent } from './admin-test-messages/admin-test-messages.component';

export const adminRoutes: Route[] = [
    {
        path: 'admin',
        component: AdminComponent,
        canActivate: [AuthGuardAdmin],
        children: [
            { path: '', redirectTo: '/admin/users', pathMatch: 'full' },
            { path: 'users', component: AdminUsersComponent },
            { path: 'users/add', component: AdminUserEditComponent },
            { path: 'user/:id', component: AdminUserEditComponent },
            { path: 'roles', component: AdminRolesComponent },
            { path: 'bands', component: AdminBandsComponent},
            { path: 'groups', component: AdminGroupsComponent },
            { path: 'import', component: AdminImportComponent },
            { path: 'debug', component: AdminDebugComponent },
            { path: 'currency', component: AdminCurrencyComponent },
            { path: 'jobtypes', component: AdminJobTypesComponent }
        ]
    },
    // Standalone test/debug page - deliberately NOT nested under AdminComponent's
    // tab-nav layout (and not behind AuthGuardAdmin), to match the other
    // "test" pages (/toggl/test, /timesheets/testoverunder) it links with.
    { path: 'admin/testmessages', component: AdminTestMessagesComponent },
];
